import React from 'react';
import i18n from '../../../shared/locales/no.json';

export default class NotFoundComponent extends React.PureComponent {
    render() {
        return (
            <div className="panel">
                <div className="u-text-center u-mv64">
                    <h1>{i18n.notfound.header}</h1>
                    <p>{i18n.notfound.msg}</p>
                </div>
                <img
                    alt={i18n.notfound.alt}
                    src="//www.finn.no/assets/404.jpg"
                    style={{ maxWidth: '100%' }}
                />
            </div>
        );
    }
}
